// import { StandardRPCJsonSerializer } from "@orpc/client/standard"
import type { QueryClientConfig } from "@tanstack/solid-query"

// const serializer = new StandardRPCJsonSerializer({
//   customJsonSerializers: [
//     // put custom serializers here
//   ]
// })

export const queryClientOptions: QueryClientConfig = {
  defaultOptions: {
    queries: {
      // queryKeyHashFn(queryKey) {
      //   const [json, meta] = serializer.serialize(queryKey)
      //   return JSON.stringify({ json, meta })
      // },
      staleTime: 60 * 1000, // > 0 to prevent immediate refetching on mount
      experimental_prefetchInRender: true
    }
    // dehydrate: {
    //   serializeData(data) {
    //     const [json, meta] = serializer.serialize(data)
    //     return { json, meta }
    //   }
    // },
    // hydrate: {
    //   deserializeData(data) {
    //     return serializer.deserialize(data.json, data.meta)
    //   }
    // }
  }
}
